// Copyright (c) 2018 Deere & Company

import {isValidDate} from '../../../shared/services/build-date';
import moment from 'moment/moment';

export const getClassName = key =>
    key === 'R' ?
        '' :
        'claim-required';

export const modifiedDate = date =>
    isValidDate(date) ?
        moment.utc(date).valueOf() :
        null;



// WEBPACK FOOTER //
// ./src/claim/battery/services/utilities.js